
export const mobileMaxScreenWidth = 768; // px
export const tabletMaxScreenWidth = 992; // px

export const isMobileScreenSize = (size: number) => size <= mobileMaxScreenWidth;
export const isTabletScreenSize = (size: number) => size <= tabletMaxScreenWidth && size > mobileMaxScreenWidth;